import { ref, watch, reactive } from 'vue';

interface UseBudgetAllocationsDrawerState {
  budgetGroupTwrn: string;
  isOpen: boolean;
  onSuccess: (() => void) | undefined;
}

const DEFAULT_STATE: UseBudgetAllocationsDrawerState = {
  budgetGroupTwrn: '',
  isOpen: false,
  onSuccess: undefined,
};

const getDefaultState = () => ({ ...DEFAULT_STATE });

const state = reactive<UseBudgetAllocationsDrawerState>(getDefaultState());

function resetState() {
  Object.assign(state, getDefaultState());
}

const isRendered = ref<boolean>(false);

watch(() => state.isOpen, (isOpen) => {
  if (isOpen && !isRendered.value) isRendered.value = true;
  if (!isOpen) resetState();
});

interface useBudgetAllocationsDrawerOptions {
  onSuccess?: () => void;
}

export function useBudgetAllocationsDrawer(options?: useBudgetAllocationsDrawerOptions) {
  function open(budgetGroupTwrn: string) {
    state.isOpen = true;
    state.onSuccess = options?.onSuccess;
    state.budgetGroupTwrn = budgetGroupTwrn;
  }

  return {
    state,
    isRendered,
    resetState,
    open,
  };
}
